//------------------------------------------------------------------------------
// ReportDefinition component
//------------------------------------------------------------------------------
import React, { useContext, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";

// contexts
import AuthContext from '../../../../utils/authProvider'

// apollo & operations
import { useQuery, useMutation } from "@apollo/client";
import { QUERY_DISTRICT_REPORTS } from "../../../../operations/queries/districtreports";
import { QUERY_USER_DISTRICT_REPORTS } from "../../../../operations/queries/districtreports";
import { UPDATE_DISTRICT_REPORT } from "../../../../operations/mutations/reportBuilder/Common";
import { INSERT_DISTRICT_REPORT } from "../../../../operations/mutations/reportBuilder/Common";
import { DELETE_DISTRICT_REPORT } from "../../../../operations/mutations/reportBuilder/Common";

import _ from 'lodash';

// ant design
import { Form, Button, Col, Input, message, Popconfirm, Row, Select, Space, Tooltip, TreeSelect, Typography } from "antd";
const { Option, OptGroup } = Select;
const { Paragraph, Title, Text } = Typography
const { TextArea } = Input

import {
  DeleteOutlined,
  ExportOutlined,
  InfoCircleOutlined,
} from '@ant-design/icons'

import { Link } from 'react-router-dom'

// Modals
import ReportPageLayoutModal from "./ReportPageLayoutModal";
import ReportDistributionModal from "./ReportDistributionModal"
import ReportColumnsDetailModal from "./ReportColumnsDetailModal"
import ReportSchedulingModal from "./ReportSchedulingModal"
import ReportDefSaveAsModal from "./ReportDefSaveAsModal";

//Functions
import { 
  isReportDefChanged,
  getReportTableColumnFilterValues, 
  getReportTableColumnRender, 
  handleReportTableFilter, 
  handleReportTableSort, 
  removeTypename,
} from "./Functions";

import './ReportBuilder.css'

import {
  notificationError,
  notificationInfo,
  notificationSuccess,
} from '../../../../utils/notification'
import { remove } from "lodash";
import { render } from "@testing-library/react";

const ReportDefinition = ({
  form,
  reportGroup,
  DataFiltersComponent,  //e.g. store selector or district selector, etc
  districtIds,

  reportDefsRef,
  reportDefRef,
  selectedReportDefId,
  setSelectedReportDefId,

  reportPreviewTitle,
  setReportPreviewTitle,
  reportPreviewNotes,
  setReportPreviewNotes,

  reportTableColumns,
  setReportTableColumns,
  reportTableExtraDatasource,
  setreportTableExtraDatasource,
  reportTableExtraData,
  setreportTableExtraData,
  reportTableHasFilters,
  setReportTableHasFilters,
  reportTableHasSorts,
  setReportTableHasSorts,
  reportTableSortState,
  setReportTableSortState,

  reportDefChanged,
  setReportDefChanged,

  DataFiltersComponentName,
  DataFiltersComponentLabel,

  name,
  label,
  validateStatus,
  help,
  hasFeedback,

  isMountedRef,

}) => {
  // const [form] = Form.useForm()
  // if (!reportDefRef?.current?.selectedFields) return;
  // if (!isMountedRef) return;

  //--------
  // Auth
  //--------
  const Auth = useContext(AuthContext)
  const isSuperAdmin = Auth.hasRole('SUPER_ADMIN')
  const isSchoolsGeneral = Auth.hasRole('SCHOOLS_GENERAL')
  const isSchoolsAdmin = Auth.hasRole('SCHOOLS_ADMIN')
  const isDistrictsAdmin = Auth.hasRole('DISTRICTS_ADMIN')
  //console.log('auth',Auth)

  //--------
  // Modals state
  //--------
  const [isReportPageLayoutModalOpen, setIsReportPageLayoutModalOpen] = useState(false);
  const showReportPageLayoutModal = () => {setIsReportPageLayoutModalOpen(true)}

  const [isReportDistributionModalOpen, setIsReportDistributionModalOpen] = useState(false);
  const showReportDistributionModal = () => {setIsReportDistributionModalOpen(true)}

  const [isReportColumnsDetailModalOpen, setIsReportColumnsDetailModalOpen] = useState(false)
  const showReportColumnsDetailModal = () => {setIsReportColumnsDetailModalOpen(true)}  

  const [isReportSchedulingModalOpen, setIsReportSchedulingModalOpen] = useState(false);
  const showReportSchedulingModal = () => {setIsReportSchedulingModalOpen(true)}

  const [isReportDefSaveAsModalOpen, setIsReportDefSaveAsModalOpen] = useState(false)
  const showReportDefSaveAsModal = () => {setIsReportDefSaveAsModalOpen(true)}

  //Processing state
  const [isProcessing, setIsProcessing] = useState(false)
  const [isSavingDef, setIsSavingDef] = useState(false);
  const [isSavingAsDef, setIsSavingAsDef] = useState(false);
  const [isDeletingDef, setIsDeletingDef] = useState(false);

  //Form elements state
  const [newDistrictReportName, setNewDistrictReportName] = useState()
  const [availableFieldsTree, setAvailableFieldsTree] = useState()

  const [forceRerender, setForceRerender] = useState(false);

  //Reference for original reportDefRef before any changes.
  const originalReportDefRef = useRef({})

  //--------
  //Error handling
  //--------
  // const [formError, setFormError] = useState()  //why do these crash app?
  // const [itemErrors, setItemErrors] = useState({})
  const setErrors = errors => {
    // errors.itemErrors
    //   ? setItemErrors(errors.itemErrors)
    //   : setFormError(errors.formError) 
  }

  const clearErrors = () => {
    // setFormError()
    // setItemErrors({})
  }

  //--------
  // District reports persistence
  //--------
  const [updateDistrictReport, { loading: updateLoading }] = useMutation(
    UPDATE_DISTRICT_REPORT
  )
  const [insertDistrictReport, { loading: insertDistrictReportloading }] = useMutation(
    INSERT_DISTRICT_REPORT
  )
  const [deleteDistrictReport, { loading: deleteLoading }] = useMutation(
    DELETE_DISTRICT_REPORT
  )

  // const { data: districtReportDocs, loading, error, refetch: refetchDistrictReports } = useQuery(QUERY_DISTRICT_REPORTS, { //add requery?
  //   variables: { districtIds: districtIds, reportGroup: reportGroup }
  // })
  const { data: districtReportDocs, loading, error, refetch: refetchDistrictReports } = useQuery(QUERY_USER_DISTRICT_REPORTS, { //add requery?
    variables: { districtIds: districtIds, reportGroup: reportGroup },
    fetchPolicy: 'cache-first',
  })

  const [districtReports, setDistrictReports] = useState([])
  useEffect(() => {
    if (districtReportDocs?.userDistrictReports) {
      reportDefsRef.current = districtReportDocs.userDistrictReports;
      setDistrictReports(districtReportDocs.userDistrictReports);
    }
  }, [districtReportDocs]);

  const handleDistrictReportsRefetch = async (action) => {
    //refetch is relatively slow.  Rewrite this to remove district report from districtReports state instead?
    // console.log('In handleDistrictReportsRefresh',reportDefsRef.current,action)
    try {
      const { data } = await refetchDistrictReports();
      // if (data) {
        setDistrictReports(data.userDistrictReports)
        reportDefsRef.current = data.userDistrictReports
        if (action === 'delete') {  //clear selection if reportDef deleted
          reportDefRef.current = {}
          setSelectedReportDefId(null)
        }
        if (action === 'saveas') {  //set selection to new report name if saveas
          //setSelectedReportDefId(reportDefRef.current.id)
          //form.setFieldValue("districtReportSelector", reportDefRef.current.reportName)
        } 
      // }
    } catch (error) {
      console.error("Error refetching district reports:", error);
    }

  };

  if (loading) return 'Loading...'
  if (error) return `Error! ${error.message}`

  const saveReportDef = async () => {
    if (!reportDefRef) {return}
    setIsSavingDef(true)
    setIsProcessing(true)

    //Build report def from reportDefRef
    // NOTE: This is somewhat verbose because our apollo server is configured to automatically insert __typename for typed objects in queries.
    //       It could be configured to not do this but __typename is used by caching so we want it.
    //       That's why we have to enumerate each field to be updated removing __typename as necessary
    const reportDef = {...reportDefRef.current}
    const districtReportDoc = loadDistrictReportDocFromReportDefRef()
    try {
      clearErrors()
      const mutated = await updateDistrictReport({
        variables: { id: reportDefRef.current.id, districtReportInput: districtReportDoc }
      })
      originalReportDefRef.current = reportDefRef.current

      notificationSuccess('Report definition saved')
    } catch (e) {
      if (e) {
        console.log(e, 'error')
      }
      message.error(
        'Error(s) need to be corrected before the report definition can be saved.'
      )
      //setErrors(formatErrors(e))
    }

    setIsProcessing(false)
    setIsSavingDef(false)
  }

  const saveAsReportDef = async (newDistrictReportName, isUserReport, userId) => {
    if (!reportDefRef) {return}
    setIsSavingAsDef(true)
    setIsProcessing(true)
    try {
      clearErrors()
      const districtReportDoc = loadDistrictReportDocFromReportDefRef()
      delete districtReportDoc.id
      districtReportDoc.reportName = newDistrictReportName  //Load new report name from modal
      districtReportDoc.isUserReport = isUserReport
      districtReportDoc.userId = userId ? userId : null
      districtReportDoc.createdBy = Auth.email
      const mutated = await insertDistrictReport({  //Insert new report def into districtreports collection
        variables: { districtReportInput: districtReportDoc }
      })
      reportDefRef.current.reportName = newDistrictReportName //Update reportDefRef.current to reflect new reportName and id
      reportDefRef.current.isBaseReport = false //saveAs only creates user or district reports.  Base reports are seeded.
      reportDefRef.current.isUserReport = isUserReport
      reportDefRef.current.userId = userId ? userId : null
      reportDefRef.current.id = mutated.data.insertDistrictReport.id
      reportDefRef.current.createdBy = Auth.email

      await handleDistrictReportsRefetch('saveas')  //Refresh district reports list so it reflects just added report def
      setSelectedReportDefId(mutated.data.insertDistrictReport.id)
      originalReportDefRef.current = reportDefRef.current
      notificationSuccess('Report definition saved')
    } catch (e) {
      if (e) {
        if (e.message === "Report already exists") {
            notificationError("Report name already exists.  Report not saved.")
        } else {
          message.error('Error(s) need to be corrected before the report definition can be saved.')         
        }
      }
      //setErrors(formatErrors(e))
    }
    form.setFieldValue("districtReportSelector", newDistrictReportName)

    setIsProcessing(false)
    setIsSavingAsDef(false)
  }

  const deleteReportDef = async () => {
    if (!reportDefRef) {return}
    setIsDeletingDef(true)
    setIsProcessing(true)

    const districtReportDoc = loadDistrictReportDocFromReportDefRef()
    reportDefRef.current = {...reportDefRef.current, hidden: true}
    // console.log('In deleteReportDef',reportDefRef.current)

    try {
      clearErrors()
      //Following to mark as hidden
      // const mutated = await updateDistrictReport({
      //   variables: { id: reportDefRef.current.id, districtReportInput: districtReportDoc }
      // })

      //Following to physically remove from db
      // console.log('before graphql delete',reportDefRef.current.id)
      const mutated = await deleteDistrictReport({
        variables: { id: reportDefRef.current.id }
      })

      await handleDistrictReportsRefetch('delete')
      form.setFieldValue("districtReportSelector", null)

      notificationSuccess('Report definition deleted')
    } catch (e) {
      if (e) {
        console.log(e, 'error')
      }
      message.error(
        'Error(s) need to be corrected before the report definition can be deleted.'
      )
      //setErrors(formatErrors(e))
    }
    setIsDeletingDef(false)
    setIsProcessing(false)

  }

  const changeReportTitle = e => {  //Updates title in report preview
    //setReportTitle(e.target.value)
    setReportPreviewTitle(e.target.value)
    reportDefRef.current = {...reportDefRef.current, reportTitle: e.target.value}
  }
  const changeReportNotes = e => {  //Updates notes in report preview
    //setReportNotes(e.target.value)
    setReportPreviewNotes(e.target.value)
    reportDefRef.current = {...reportDefRef.current, reportNotes: e.target.value}
  }

  //--------
  //Open selected report definition
  //--------
  const openReportDef = (value, event) => {
    //Find the selected districtReport def in the list of all district report defs
    //At some point may want to make reportDefsRef just a list of available report defs with id and then query the selected def here
    const newReportDefRef =  reportDefsRef.current.find(
      ({ id }) => id === value
    )
    if (!newReportDefRef) {return}

    //Set current reportDefRef and keep a copy of original values for later change check
    reportDefRef.current = newReportDefRef
    originalReportDefRef.current = newReportDefRef

    //Set availableFields from base report
    const baseReportAvailableFields = newReportDefRef.baseReport.fields ? newReportDefRef.baseReport.fields : null
    loadAvailableFieldsTreeData(baseReportAvailableFields)

    //Set report table columns
    const selectedFieldNames = reportDefRef.current.selectedFields.map((field) => field.fieldName)
    let newColumns = []
    for (const field of selectedFieldNames) {
      newColumns.push(getReportTableColumnObject(field, newReportDefRef))
    }

    //Set any saved filters
    const savedFilters = newReportDefRef?.reportTableFilters ? newReportDefRef.reportTableFilters : {}
    const tableHasFilters = Object.values(savedFilters).some(value => 
      Array.isArray(value) && value.length > 0
    );
    // console.log('reportdef',newColumns,savedFilters,savedFilters['submittedDataStudentFullName'])
    if (tableHasFilters) {
      newColumns = newColumns.map(column => ({
        ...column,
        filteredValue: savedFilters?.[column?.dataIndex] ?? null,
      }));
      setReportTableHasFilters(true)
    }

    //Set any saved sorts
    const savedSorter = newReportDefRef?.reportTableSorter ? newReportDefRef.reportTableSorter : {}
    const tableHasSorter = !!(savedSorter && savedSorter.field && savedSorter.order)
    if (tableHasSorter) {
      newColumns = newColumns.map(column => ({
        ...column,
        sortOrder: savedSorter.field === column.dataIndex ? savedSorter.order : null,
      }));
      setReportTableSortState(savedSorter)
      setReportTableHasSorts(true)
    }

    //Let user know if any filters or sorts were applied
    if (tableHasFilters || tableHasSorter) {
      let infoMessage = ''
      if (tableHasFilters & tableHasSorter) {infoMessage = 'FYI, previously saved filters and sorts were loaded.  Your report data will reflect these filters/sorts.'}
      if (tableHasFilters & !tableHasSorter) {infoMessage = 'FYI, previously saved filters were loaded.  Your report data will reflect these filters.'}
      if (!tableHasFilters & tableHasSorter) {infoMessage = 'FYI, previously saved sorts were loaded.  Your report data will reflect this sort.'}
      // console.log(infoMessage,tableHasFilters,tableHasSorter)
      notificationInfo(infoMessage)
    }

    //Update form fields values
    form.setFieldValue("reportTitle",reportDefRef.current.reportTitle)
    form.setFieldValue("reportNotes",reportDefRef.current.reportNotes)

    //Update state
    setSelectedReportDefId(value)
    setReportDefChanged(false)
    //setDataNeedsRefresh(false)
    setReportPreviewTitle(reportDefRef.current.reportTitle)
    setReportPreviewNotes(reportDefRef.current.reportNotes)
    setReportTableColumns([...newColumns])
    setreportTableExtraDatasource([])
    setreportTableExtraData([])
    setIsProcessing(false)
  }


  //? do this or just handleAvailableFieldsOnChange
  const removeReportTableColumn = (fieldName, option) => {

    //Set fields to be removed based on whether this is a group deselect (option has children element) or individual field
    let removedFields = []
    if(option?.children) {
      removedFields = option.children.map(column => column.key)
    } else {
      removedFields = [fieldName]
    }
    
    //Removed fields from existing reportTableColumns
    const remainingColumns = reportTableColumns.filter(column => !removedFields.includes(column.dataIndex));
    setReportTableColumns(remainingColumns)

    //Update selected fields
    if (reportDefRef?.current?.selectedFields) {
      const newSelectedFields = reportDefRef.current.selectedFields.filter(field => {return field.fieldName !== fieldName}) //Filter existing columns to all columns EXCEPT the passed fieldName 
      const updatedDefRef = {...reportDefRef.current}
      updatedDefRef.selectedFields = newSelectedFields
      reportDefRef.current = {...updatedDefRef}
    }

  }

  //==============================================================================
  //Available fields selector related functions
  //==============================================================================
  //--------
  //Update reportDefRef's selectedFields using list of fieldNames returned by available fields selector
  //--------
  const handleAvailableFieldsOnChange = value => {
    const newSelectedFieldNames = value //All selected fields in availableFieldsSelector

    //Load an array containing field defs
    let newSelectedFields = []
    for (const newFieldName of newSelectedFieldNames) {
      const baseFieldDef = reportDefRef?.current?.baseReport?.fields.find(
        ({ fieldName }) => fieldName === newFieldName
      )
      newSelectedFields.push(baseFieldDef)
    }

    //Update reportDefRef
    let updatedDefRef = {...reportDefRef.current}
    updatedDefRef.selectedFields = newSelectedFields
    reportDefRef.current = {...updatedDefRef}
    
    //Load antd report table columns
    let newColumns = []
    for (const field of newSelectedFieldNames) {
      newColumns.push(getReportTableColumnObject(field, reportDefRef.current))
    }
    setReportTableColumns([...newColumns])

  }

  //--------
  //Return a reportTable column object for fieldName
  //The basic approach is to load data from district report first and then default to base report if it doesn't exist
  //--------
  const getReportTableColumnObject = (newFieldName, districtReport) => {
    //Get the field defs for the base and district reports
    const baseFieldDef = reportDefRef?.current?.baseReport?.fields.find(
      ({ fieldName }) => fieldName === newFieldName
    )
    if (!baseFieldDef) {return} //The requested field name must be in the base report's list of available fields

    const districtFieldDef = reportDefRef?.current?.selectedFields.find(
      ({ fieldName }) => fieldName === newFieldName
    )

    //const fieldGroup = districtFieldDef ? districtFieldDef.fieldGroup : baseFieldDef.fieldGroup;
    const fieldCaption = districtFieldDef
      ? districtFieldDef.fieldCaption
      : baseFieldDef.fieldCaption
    //const fieldOrder = districtFieldDef ? districtFieldDef.fieldOrder : baseFieldDef.fieldOrder;
    const fieldWidth = districtFieldDef
      ? districtFieldDef.fieldWidth
      : baseFieldDef.fieldWidth
    const fieldAlignment = districtFieldDef
      ? districtFieldDef.fieldAlignment
      : baseFieldDef.fieldAlignment
    const fieldHasFilter = districtFieldDef
      ? districtFieldDef.fieldHasFilter
      : baseFieldDef.fieldHasFilter
    const fieldHasSort = districtFieldDef
      ? districtFieldDef.fieldHasSort
      : baseFieldDef.fieldHasSort
    const tooltipText = districtFieldDef
      ? districtFieldDef.tooltipText
      : baseFieldDef.tooltipText

    let newColumn = {
      key: newFieldName,
      ////title: <><span onClick={(e) => {handleColumnHeaderEdit(newFieldName); e.stopPropagation()}}><EditOutlined /></span><span style={{ color: 'darkblue' }} onClick={(e)=>{e.stopPropagation()}} >{fieldCaption}</span></>,
      ////title: <span style={{ color: 'darkblue' }} >{fieldCaption}</span>,
      //title: <span className='dragHandler'>{fieldCaption}</span>,
      title: (
        <span>
          {tooltipText && (// only if tooltip text exists
            <Tooltip title={tooltipText}>
              <InfoCircleOutlined style={{ cursor: 'pointer' }} />
              {' '}
            </Tooltip>
            )
          }
          <span className="dragHandler">{fieldCaption}</span>
        </span>
      ),
      showSorterTooltip: false, //turn off sort message because it interferes with field tooltip
      //If we update to antd >5.16 we can use the following to just display message over arrows 
      // showSorterTooltip: {
      //   target: 'sorter-icon',          // <— only on the arrows
      //   title: 'Click to sort',         // optional custom text
      // },

      dataIndex: newFieldName,
      filterMultiple: true,
      align: fieldAlignment,
      //filteredValue: null,
      //filters: filterValues,
      filterSearch: true,
      defaultSortOrder: 'ascend',
      //showSorterTooltip: false,
      onFilter: (value, record) =>
        handleReportTableFilter(value, record, newFieldName, reportDefRef),
      render: (value, record) => getReportTableColumnRender (value, record, baseFieldDef),
      onCell: () => ({
        style: {  minWidth: 120, whiteSpace: 'nowrap' }
      }),
    }

    if (fieldAlignment !== '') {
      newColumn.align = fieldAlignment
    }
    if (fieldWidth > 0) {
      newColumn.width = fieldWidth
    }

    if (fieldHasFilter) {
      newColumn.filters = getReportTableColumnFilterValues(
        newFieldName,
        reportTableExtraData,
        reportDefRef,
      )
      newColumn.onFilter = (value, record) =>
        handleReportTableFilter(value, record, newFieldName, reportDefRef)
    }

    if (fieldHasSort) {
      newColumn.sorter = (a, b) => handleReportTableSort(a, b, newFieldName, reportDefRef)
    }

    return newColumn
  }

  //--------
  //Remove an antd table column when a field is deselected from the list of availableFields
  //--------
  const handleAvailableFieldsOnDeselect = (fieldName, option) => {
    removeReportTableColumn(fieldName, option)
  }

  //--------
  //Save
  //--------
  const loadDistrictReportDocFromReportDefRef = () => {
    if (!reportDefRef) {return}

    const reportDef = {...reportDefRef.current}
    let districtReportDoc = {}

    districtReportDoc.districtId = reportDef.districtId
    districtReportDoc.userId = reportDef.userId
    districtReportDoc.isUserReport = reportDef.isUserReport
    districtReportDoc.baseReportId = reportDef.baseReportId

    districtReportDoc.reportCode = reportDef.reportCode
    districtReportDoc.reportName = reportDef.reportName
    districtReportDoc.reportGroup = reportDef.reportGroup

    districtReportDoc.reportTitle = reportDef.reportTitle
    districtReportDoc.reportNotes = reportDef.reportNotes
    districtReportDoc.reportRowNotes = reportDef.reportRowNotes
    districtReportDoc.reportParameters = reportDef.reportParameters
    districtReportDoc.selectedFields = removeTypename(reportDef.selectedFields)
    districtReportDoc.reportColumns = removeTypename(reportDef.reportColumns)
    districtReportDoc.reportTableFilters = reportDef.reportTableFilters
    districtReportDoc.reportTableSorter = reportDef.reportTableSorter

    districtReportDoc.filterValues = reportDef.filterValues
    districtReportDoc.grouping = removeTypename(reportDef.grouping)
    districtReportDoc.pageLayout = removeTypename(reportDef.pageLayout)
    districtReportDoc.hidden = reportDef.hidden
    districtReportDoc.distribution = removeTypename(reportDef.distribution)
    districtReportDoc.schedule = removeTypename(reportDef.schedule)

    return districtReportDoc
  }

  //--------
  //Load report selection options
  //--------
  const reportGroupOptions = {
    base: [],
    district: [],
    user: [],
  };

  if (districtReportDocs?.userDistrictReports) {
    //Load district/user report groups
    districtReportDocs?.userDistrictReports.forEach(report => {
      if (report.isBaseReport) {
        reportGroupOptions['base']?.push(report)
      } else if (report.isUserReport) {
        reportGroupOptions['user']?.push(report)
      } else {
        reportGroupOptions['district']?.push(report)
      }
    });

    //sort the groups (could put a reportGroup(e.g. Schools, Districts, etc.) as well.  So district/report group/report name instead of district/report name
    const sortByReportName = (a, b) => {
      return a.reportName.localeCompare(b.reportName);
    };
    reportGroupOptions.base.sort(sortByReportName);


    const sortByDistrictNametThenReportName = (a, b) => {
      if (a.district?.name < b.district?.name) return -1;
      if (a.district?.name > b.district?.name) return 1;
      return a.reportName.localeCompare(b.reportName);
    };
    reportGroupOptions.district.sort(sortByDistrictNametThenReportName);

    const sortByDistrictThenUserEmailThenReportName = (a, b) => {
      if (a.district?.name < b.district?.name) return -1;
      if (a.district?.name > b.district?.name) return 1;
    
      if (a.user?.email < b.user?.email) return -1;
      if (a.user?.email > b.user?.email) return 1;
    
      return a.reportName.localeCompare(b.reportName);
    };

    // const sortByUserEmailThenReportName = (a, b) => {
    //   if (a.user.email < b.user.email) return -1;
    //   if (a.user.email > b.user.email) return 1;
    //   return a.reportName.localeCompare(b.reportName);
    // };
    reportGroupOptions.user.sort(sortByDistrictThenUserEmailThenReportName);

  }
  //console.log('group options',reportGroupOptions)

  const loadAvailableFieldsTreeData = (availableFields) => {
    if (!reportDefRef) {
      return
    }

    let availableFieldsTreeData = []
    const fieldGroupIds = [
      ...new Set(availableFields.map(field => field.fieldGroup))
    ] //Unique fieldGroups in availableFields
    for (const fieldGroupId of fieldGroupIds) {
      const fieldGroupFields = availableFields.filter(field => {
        return field.fieldGroup === fieldGroupId
      }) //All fields in the current fieldGroup
      let fieldGroupChildren = []
      for (const fieldGroupField of fieldGroupFields) {
        //Load the list of child fields for the current filedGroup
        fieldGroupChildren.push({
          key: fieldGroupField.fieldName,
          value: fieldGroupField.fieldName,
          title: fieldGroupField.fieldCaption
        })
      }
      availableFieldsTreeData.push({
        key: fieldGroupId,
        value: fieldGroupId,
        title: fieldGroupId,
        selectable: false,
        children: fieldGroupChildren
      })
    }
    setAvailableFieldsTree(availableFieldsTreeData)
    const selectedFieldNames = reportDefRef?.current?.selectedFields?.map((field) => field.fieldName);
    // if (selectedFieldNames) {
      form.setFieldValue('availableFieldsTreeSelect', selectedFieldNames);
    // }
  }

  //set disabled of save, saveas and delete buttons
  //NOTE: sequence of tests matters
  const setDefSaveDisabled = () => {
    if (!selectedReportDefId) {return true}
    if (isProcessing) {return true}
    if (isSuperAdmin) {return false}
    if (isDistrictsAdmin && reportDefRef?.current?.isBaseReport) {return true}
    if ((isSchoolsAdmin || isSchoolsGeneral) && !reportDefRef?.current?.isUserReport) {return true}
    if (!selectedReportDefId || isProcessing) {return true}
  }
  const setDefSaveAsDisabled = () => {
    if (!selectedReportDefId) {return true}
    if (isProcessing) {return true}
  }
  const setDefDeleteDisabled = () => {
    if (!selectedReportDefId || isProcessing) {return true} //reportDefRef not loaded or disabled durint processing
    if (isSuperAdmin && !reportDefRef?.current?.isBaseReport) {return false}
    if (!isSuperAdmin && reportDefRef?.current?.isBaseReport) {return true} //If your not a superAdmin and its a base report you can't delete
    if (isDistrictsAdmin && !reportDefRef?.current?.isBaseReport) {return false}
    if (!isDistrictsAdmin && !reportDefRef?.current?.isUserReport) {return true}  //If your not a districtsAdmin and it's a district report(not a user report) you can't delete
    if ((isSchoolsAdmin || isSchoolsGeneral) && reportDefRef?.current?.isUserReport) {return false}
    return (true)
  }
  const animateSaveButton = () => {
    if (setDefSaveDisabled()) {return false}
    return isReportDefChanged(originalReportDefRef.current, reportDefRef.current)
  }

  return (
    <>
      <Form.Item 
        wrapperCol={{ xs: { offset: 7 }, sm: { offset: 6 }, md: { offset: 5 }, lg: { offset: 4 }, xl: { offset: 3 } }}
        style={{marginBottom: '16px'}}
      >
        <Space wrap>
          {/* Save */}
          <Tooltip
            title={
              animateSaveButton()
                ? 'Your report definition has changed. Click here to save the changes'
                : ''
            }
          >
            <Button
              className={animateSaveButton() ? 'pulse-button' : ''}
              disabled={setDefSaveDisabled()}
              loading={isSavingDef}
              onClick={saveReportDef}
            >
              {reportDefRef?.current?.isBaseReport && !isSuperAdmin
                ? 'Base Report'
                : 'Save'}
            </Button>
          </Tooltip>

          {/* Save As */}
          <Button
            disabled={setDefSaveAsDisabled()}
            loading={isSavingAsDef}
            onClick={showReportDefSaveAsModal}
          >
            Save As
          </Button>

          {/* Delete */}
          <Popconfirm
            title='Are you sure you want to delete this report?'
            icon={<DeleteOutlined style={{ color: 'red' }} />}
            placement='rightBottom'
            onConfirm={deleteReportDef}
            okText='Yes'
            cancelText='No'
            disabled={setDefDeleteDisabled()}
          >
            <Button disabled={setDefDeleteDisabled()} loading={isDeletingDef}>
              {reportDefRef?.current?.isBaseReport ? 'Base Report' : 'Delete'}
            </Button>
          </Popconfirm>

          {/* Log button -- super-admins only */}
          {isSuperAdmin && (
            <Button
              onClick={() =>
                console.log(
                  'reportDefRef',
                  reportDefRef,
                  originalReportDefRef,
                  isReportDefChanged(originalReportDefRef.current, reportDefRef.current)
                )
              }
            >
              Log reportDefRef.current
            </Button>
          )}
        </Space>
      </Form.Item>
      <Form.Item
        label={<span style={{ color: !selectedReportDefId ? "red" : "black" , fontWeight: !selectedReportDefId ? "bold" : "normal", fontSize: !selectedReportDefId ? "fontSizeXl" : "fontSize"} }>Select a Report:</span>}
        name='districtReportSelector'
        validateStatus={validateStatus}
        help={help}
        hasFeedback={hasFeedback}
        requiredMark={"required"}
        rules={[
          {
            required: true,
            message: (
              <Paragraph type="danger">
                A report definition must be selected
              </Paragraph>
            ),
          },
        ]}
      >
        <Select
          disabled={isProcessing}
          placeholder='Select a report definition to begin'
          loading={loading}
          optionFilterProp="children"
          onChange={(value, event) => {
            openReportDef(value, event)
          }}
          showSearch={true}
          listHeight={320} //Each option is 32px in standard size so listHeight=320 is 10 options
        >
          {reportGroupOptions.base.length > 0 && (
            <OptGroup label={<span style={{ fontWeight: 'bold', fontSize: '1rem', color: '#152E50' }}>Base Reports</span>}>
              {reportGroupOptions.base.map(report => (
                <Option key={report.id} value={report.id}>
                  {report.reportName + " (" + report?.district?.name + ")"}
                  </Option>
              ))}
            </OptGroup>
          )}   
          {reportGroupOptions.district.length > 0 && (
            <OptGroup label={<span style={{ fontWeight: 'bold', fontSize: '1rem', color: '#152E50' }}>District Reports</span>}>
              {reportGroupOptions.district.map(report => (
                <Option key={report.id} value={report.id}>
                  {report.reportName + " (" + report?.district?.name + ")"}
                </Option>
              ))}
            </OptGroup>
          )}
          {reportGroupOptions.user.length > 0 && (
            <OptGroup label={<span style={{ fontWeight: 'bold', fontSize: '1rem', color: '#152E50' }}>User Reports</span>}>
              {reportGroupOptions.user.map(report => (
                <Option key={report.id} value={report.id}>
                {report.reportName + " (" + report?.user?.email + ")"}
                </Option>
              ))}
            </OptGroup>
          )}

         </Select>
      </Form.Item>

      <Form.Item 
        name='reportTitle' 
        label='Report Title'
        colon={true}
        style={{ width: '100%', marginTop: "8px" }}
      >
        <Input
          type='text'
          onChange={changeReportTitle}
          placeholder='Title your report.'
          disabled={!selectedReportDefId || isProcessing}
          // initialValue={reportDefRef.current.reportTitle}
        />
      </Form.Item>

      <Form.Item
        name='reportNotes'
        label='Notes'
        colon={true}
        style={{ width: '100%', marginTop: "8px" }}
      >
        <TextArea
          type='text'
          onChange={changeReportNotes}
          placeholder='Enter any comments you would like on this report.'
          disabled={!selectedReportDefId || isProcessing}
          // initialValue={reportDefRef.current.reportNotes}
          rows={2}
        />
      </Form.Item>

      <Form.Item
        label='Select Column(s)'
        colon={true}
        name='availableFieldsTreeSelect'
        required={true}
        style={{ width: '100%', marginTop: "8px" }}
      >
        <TreeSelect
          name='availableFieldsTreeSelect'
          showAction='focus'
          allowClear
          label="Select Column(s)"
          disabled={!selectedReportDefId || isProcessing}
          multiple
          showSearch={true}
          listHeight={640} //Each option is 32px in standard size so listHeight=320 is 10 options
          onChange={value => handleAvailableFieldsOnChange(value)}
          onDeselect={(value, option) => handleAvailableFieldsOnDeselect(value, option)}
          // onDeselect={value => handleAvailableFieldsOnDeselect(value)}
          placeholder='Select the fields you want to see on your report'
          showCheckedStrategy='SHOW_CHILD'
          treeCheckable={true}
          treeData={availableFieldsTree}
          treeDefaultExpandAll
        />
      </Form.Item>

      <Form.Item
        name={DataFiltersComponentName}
        label={DataFiltersComponentLabel}
        colon={true}
        required={true}
        >

        <DataFiltersComponent
          reportDefRef={reportDefRef}
          disabled={!selectedReportDefId || isProcessing}
          mode='multiple'
          reportDefChanged={reportDefChanged}
          setReportDefChanged={setReportDefChanged}
        />
      </Form.Item>
      <Form.Item
        style={{ marginTop: 16 }}
        wrapperCol={{ xs: { offset: 7 }, sm: { offset: 6 }, md: { offset: 5 }, lg: { offset: 4 }, xl: { offset: 3 } }}
      >
        <Space wrap>
          <Tooltip title="Open report page layout settings">
            <Button
              disabled={!selectedReportDefId || isProcessing}
              onClick={showReportPageLayoutModal}
              icon={<ExportOutlined />}
            >
              Page Layout
            </Button>
          </Tooltip>

          <Tooltip title="Open report distribution settings">
            <Button
              disabled={!selectedReportDefId || isProcessing}
              onClick={showReportDistributionModal}
              icon={<ExportOutlined />}
            >
              Report Distribution
            </Button>
          </Tooltip>

          {isSuperAdmin && (
            <>
              <Tooltip title="Report columns detail">
                <Button
                  disabled={!selectedReportDefId || isProcessing}
                  onClick={showReportColumnsDetailModal}
                  icon={<ExportOutlined />}
                >
                  Report Columns Detail
                </Button>
              </Tooltip>

              <Tooltip title="Open report schedule">
                <Button
                  disabled={!selectedReportDefId || isProcessing}
                  onClick={showReportSchedulingModal}
                  icon={<ExportOutlined />}
                >
                  Report Scheduling
                </Button>
              </Tooltip>
            </>
          )}
        </Space>
      </Form.Item>

      {isReportPageLayoutModalOpen && (
        <ReportPageLayoutModal
          isReportPageLayoutModalOpen={isReportPageLayoutModalOpen}
          setIsReportPageLayoutModalOpen={setIsReportPageLayoutModalOpen}
          reportDefRef={reportDefRef}
          width={600}
        />
      )}

      {isReportDistributionModalOpen && (
        <ReportDistributionModal
          isReportDistributionModalOpen={isReportDistributionModalOpen}
          setIsReportDistributionModalOpen={setIsReportDistributionModalOpen}
          reportDefRef={reportDefRef}
          reportTableColumns={reportTableColumns}
          reportTableExtraData={reportTableExtraData}
          showSendButton={false}
          width={500}
        />
      )}

      {isReportColumnsDetailModalOpen && (
        <ReportColumnsDetailModal
          isReportColumnsDetailModalOpen={isReportColumnsDetailModalOpen}
          setIsReportColumnsDetailModalOpen={setIsReportColumnsDetailModalOpen}
          reportDefRef={reportDefRef}
          reportTableColumns={reportTableColumns}
          setReportTableColumns={setReportTableColumns}
          reportTableExtraData={reportTableExtraData}
          forceRerender={forceRerender}
          setForceRerender={setForceRerender}
          width={500}
        />
      )}

      {isReportSchedulingModalOpen && (
        <ReportSchedulingModal
          isReportSchedulingModalOpen={isReportSchedulingModalOpen}
          setIsReportSchedulingModalOpen={setIsReportSchedulingModalOpen}
          reportDefRef={reportDefRef}
          width={500}
        />
      )}

      {isReportDefSaveAsModalOpen && (
        <ReportDefSaveAsModal
          isReportDefSaveAsModalOpen={isReportDefSaveAsModalOpen}
          setIsReportDefSaveAsModalOpen={setIsReportDefSaveAsModalOpen}
          reportDefRef={reportDefRef}
          reportDefsRef={reportDefsRef}
          newDistrictReportName={newDistrictReportName}
          setNewDistrictReportName={setNewDistrictReportName}
          saveAsReportDef={saveAsReportDef}
          width={500}
        />
      )}
    </>
  )
};

// ReportDefinition.propTypes = {
//   label: PropTypes.string,
//   name: PropTypes.string,
//   help: PropTypes.help,
//   validateStatus: PropTypes.string,
//   hasFeedback: PropTypes.bool,
//   mode: PropTypes.string,
//   districtIds: PropTypes.string,
// };

export default ReportDefinition;
